class EventsBus extends Backbone.Enhanced.Events


module.exports = EventsBus
  